import Lottie from 'lottie-react';
import { maintenanceAnimation } from './maintenance-animation';
import Style from './Maintenance.style';
import { Headline, Span } from 'Common';

const Maintenance = () => {
  return (
    <Style>
      <div className="content">
        <Headline level={2}>Genau der richtige Zeitpunkt, um einmal tief durchzuatmen...</Headline>
        <Span>Schließe die Augen und nimm 10 tiefe Atemzüge. Wir machen Balloon noch schöner und sind gleich wieder für dich da.</Span>
      </div>
      <Lottie className="animation" animationData={maintenanceAnimation} loop={true} />
    </Style>
  );
};

export default Maintenance;
